import secureLocalStorage from "react-secure-storage";
import { CircularProgress } from "@material-ui/core";
import { process } from "@progress/kendo-data-query";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import React, { Component } from "react";
import Api from "../../Services/Api";
import PrePostComponenant from "../Tenant/Component/PrePostComponenant";
import * as moment from "moment";
import { formatNumber } from "@telerik/kendo-intl";
import ValidateNumberCell from "../Tasks/ValidateNumberCell";

export default class ValidateRisk extends Component {
  constructor(props) {
    super(props);
    this.state = this.createAppState({
      ...this.state,
      sort: [{ field: "code", dir: "asc" }],
      take: 10,
      skip: 0,
      loader: false,
      HeatMapConfigDataOpportunity: [],
      HeatMapConfigDataThreat: [],
      dynamicHeatmapProbabilityRange: [],
    });
  }

  componentDidMount() {
    this.init();
  }

  init = async () => {
    await this.getMatrixColorCodes();
    await this.getCustomField();
    this.getTemporaryRiskListForUploader();
  };

  getMatrixColorCodes = async () => {
    try {
      let response = await Api.MatrixColor();
      if (response.status === 200) {
        // normal,opportunity
        let normal_opp = response.matrixColor.find(
          (item) => item.riskType === "opportunity"
        );
        let opp_colorJsonData = JSON.parse(normal_opp.colorJsonData);

        //  normal,threat
        let normal_threat = response.matrixColor.find(
          (item) => item.riskType === "threat"
        );
        let threat_colorJsonData = JSON.parse(normal_threat.colorJsonData);
        this.setState({
          HeatMapConfigDataThreat: threat_colorJsonData,
          HeatMapConfigDataOpportunity: opp_colorJsonData,

          heatMapCount: response.heatmapCount,
          dynamicHeatmapProbabilityRange:
            response.dynamicHeatmapProbabilityRange,
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  getTemporaryRiskListForUploader = async () => {
    try {
      this.setState({ ...this.state, loader: true });
      const requestParams = {
        workstreamId: this.props.workstreamId,
      };
        let response = await Api.getTemporaryRiskListForUploader(requestParams);
    
      if (response.status === 200&&response.riskRegister) {
        var selectedOrgUnitArray = [];
        response.riskRegister.map((riskReg) => {
          if (riskReg.proximityDate) {
            riskReg.proximityDate = new Date(riskReg.proximityDate);
          }
          if (riskReg.createdDate) {
            riskReg.createdDate = new Date(riskReg.createdDate);
          }

          selectedOrgUnitArray.push(riskReg.organizationUnitId);
        });
        let impactMaster = [];
        if (response.riskRegister && response.riskRegister.length > 0) {
          impactMaster = response.riskRegister[0].impactResponse;
        }
        this.setState({
          ...this.state,
          impactMaster: impactMaster,
        });
        await this.createDynamicDropdowns(response.riskRegister);
        await this.createDynamicCols(response.riskRegister);

        var riskData = response.riskRegister.map((dataItem) =>
          Object.assign({ selected: false }, dataItem)
        );

        this.setState({
          ...this.state,
          riskList: riskData,
          riskTemp: riskData,
          loader: false,
        });
        this.props.handleValidateDataCount({
          newRiskCount:response.newRiskCount,
          modifiedRiskCount:response.modifiedRiskCount,
          closedRiskCount:response.closedRiskCount,
        });
      } else {
        this.setState({
          ...this.state,
          riskList: [],
          selectedOrgUnit: [],
          riskTemp: [],
          loader: false,
        });
        this.props.handleValidateDataCount({
          newRiskCount:0,
          modifiedRiskCount:0
        });
      }
    } catch (error) {
      this.setState({ ...this.state, loader: false });
    }
  };

  createDynamicDropdowns = async (products) => {
    try {
      let dropdownColumn = [];
      products.map((res, i) => {
        res.customFields &&
          res.customFields.map((item, j) => {
            if (dropdownColumn.length > 0) {
              if (
                !dropdownColumn.find((cf) => cf.fieldName === item.fieldName)
              ) {
                dropdownColumn.push({
                  fieldName: item.fieldName,
                  data: this.getCustomFieldMasterData(item.fieldName),
                  inputType: this.getInputType(item.fieldName),
                });
              }
            } else {
              dropdownColumn.push({
                fieldName: item.fieldName,
                data: this.getCustomFieldMasterData(item.fieldName),
                inputType: this.getInputType(item.fieldName),
              });
            }
          });
      });

      if (dropdownColumn.length > 0) {
        products.map((res) => {
          dropdownColumn.map((col) => {
            let temp = res.customFields.find(
              (item) => item.fieldName === col.fieldName
            );
            if (temp) {
              if (temp.inputType === "Multi Drop Down") {
                let val = temp.selectedCustomFieldNames
                  ? temp.selectedCustomFieldNames.toString()
                  : "";
                // let hashArr = this.stringToHashForCF(val, col.data);
                res[col.fieldName] = val;
              } else if (temp.inputType === "Single Drop Down") {
                let val = temp.selectedCustomFieldNames
                  ? temp.selectedCustomFieldNames.toString()
                  : "";
                res[col.fieldName] = val;
              } else if (temp.inputType === "Free Text") {
                let val = temp.multiText ? temp.multiText : "";
                res[col.fieldName] = val;
              } else if (temp.inputType === "Numeric") {
                let val = temp.multiText ? temp.multiText : "";
                res[col.fieldName] = val;
              } else if (temp.inputType === "Date") {
                let val = temp.multiText ? new Date(temp.multiText) : "";
                res[col.fieldName] = val;
              }
            } else {
              res[col.fieldName] = "";
            }
          });
        });
      }
      let columnsToShow = [];
      if (dropdownColumn.length > 0) {
        columnsToShow = dropdownColumn.map((item) => (
          <Column
            field={item.fieldName}
            title={item.fieldName}
            width="150px"
           
          />
        ));
      }
      this.setState({ ...this.state, dropdownColumns: columnsToShow });
    } catch (err) {
      console.log(err);
    }
  };

  getInputType = (fieldName) => {
    try {
      let arr = this.state.customFieldsmaster.find(
        (item) => item.fieldName == fieldName
      );
      if (arr) {
        return arr.inputType;
      } else {
        return undefined;
      }
    } catch (err) {
      console.log(err);
    }
  };

  getCustomField = async () => {
    let res = [];
    try {
      var request = {
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
      };

      let response = await Api.getCustomField(request);
      if (response.status === 200) {
        response.customFields.map((item) => {
          item.cfPossibleValues.map((item1) => {
            item1["hashValue"] = this.convertStrToHash(item1.possibleValues);
          });
        });

        this.setState({
          ...this.state,
          customFieldsmaster: [...response.customFields],
        });
      }
    } catch (err) {
      console.error("Exception:", err);
    }
    return res;
  };

  convertStrToHash = (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      let char = str.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash = hash & hash;
    }
    hash = Math.abs(hash).toString();
    return hash;
  };

  stringToHashForCF(stringArr, data) {
    let hashArr = [];
    if (stringArr && stringArr.includes(",")) {
      let valArr = stringArr.split(",");
      valArr &&
        valArr.map((item1) => {
          let cfVal = data.find((item) => item.name === item1);
          if (cfVal) {
            hashArr.push(cfVal.hashValue);
          }
        });
    } else {
      let cfVal = data.find((item) => item.name === stringArr);
      if (cfVal) {
        hashArr.push(cfVal.hashValue);
      }
    }
    return hashArr.toString();
  }



  getCustomFieldMasterData = (fieldName) => {
    try {
      let arr = this.state.customFieldsmaster.filter(
        (item) => item.fieldName === fieldName
      );
      if (arr && arr.length > 0) {
        let temp = [];
        arr[0].cfPossibleValues.map((item, index) => {
          temp.push({
            id: index,
            name: item.possibleValues,
            checked: false,
            hashValue: item.hashValue, //this.convertStrToHash(item),
          });
        });
        return temp;
      } else {
        return [];
      }
    } catch (err) {
      return [];
    }
  };

  //Impact
  createDynamicCols = async (products) => {
    let impactColumn = [];

    products.map((res, i) => {
      if (res.impactResponse) {
        res.impactResponse.map((item, j) => {
          if (impactColumn.length > 0) {
            if (!impactColumn.includes(item.name + "_" + item.type)) {
              impactColumn.push({
                fieldName: item.name + "_" + item.type,
                impactType: item.impactType,
              });
            }
          } else {
            impactColumn.push({
              fieldName: item.name + "_" + item.type,
              impactType: item.impactType,
            });
          }
        });
      }
    });
    // impactColumn.sort();
    // impactColumn.reverse();
    impactColumn = impactColumn.filter(
      (ele, ind) =>
        ind ===
        impactColumn.findIndex(
          (elem) =>
            elem.fieldName === ele.fieldName &&
            elem.impactType === ele.impactType
        )
    );
    if (impactColumn.length > 0) {
      products.map((res) => {
        impactColumn.map((col) => {
          if (col.impactType == "Qualitative") {
            let temp = res.impactResponse&&res.impactResponse.find(
              (item) => item.name + "_" + item.type === col.fieldName
            );
            if (temp&&temp.type == "Post") {
              res[col.fieldName] =  temp.postQvalue;
            }else if (temp&&temp.type == "Pre"){
              res[col.fieldName] =temp.qValue;
            }else if (temp&&temp.type == "Current"){
              res[col.fieldName] =temp.currentQvalue;
            } else {
              res[col.fieldName] = 0;
            }
          } else {
            let temp = res.impactResponse&&res.impactResponse.find(
              (item) => item.name + "_" + item.type === col.fieldName
            );
            if (temp&&temp.type == "Post") {
              res[col.fieldName] =  temp.postImpactValue;
            }else if (temp&&temp.type == "Pre"){
              res[col.fieldName] = temp.value;
            }else if (temp&&temp.type == "Current"){
              res[col.fieldName] = temp.currentImpactValue;
            } else {
              res[col.fieldName] = 0;
            }
          }
        });
      });
    }

    let columnsToShow = [];
    if (impactColumn.length > 0) {
      columnsToShow = impactColumn.map((item) => (
        <Column
          field={item.fieldName}
          title={this.getImpactUnit(item)}
          width="100px"
          editable={false}
          filter={"numeric"}
        />
      ));
    }
    this.setState({ ...this.state, impactColumns: columnsToShow });
  };

  getImpactUnit = (impact) => {
    if (impact.impactType == "Qualitative") {
      var impactTemp = this.state.impactMaster.find(
        (item) => item.name + "_" + item.type == impact.fieldName
      );
      var res = impact.fieldName;
      if (impactTemp && impactTemp.name) {
        res = impactTemp.name + " / " + " (" + impactTemp.type + ")";
      }
      return res;
    } else {
        var impactTemp = this.state.impactMaster.find(
          (item) => item.name + "_" + item.type == impact.fieldName
        );
        var res = impact.fieldName;
        if (impactTemp && impactTemp.name) {
          res =
            impactTemp.name +
            " / " +
            impactTemp.units +
            " (" +
            impactTemp.type +
            ")";
        
        return res;
      }
    }
  };

  createAppState = (dataState) => {
    if (this.state && this.state.riskTemp) {
      return {
        riskList: this.state.riskTemp.slice(0),
        dataState: dataState,
      };
    } else {
      return {
        riskList: [],
        dataState: dataState,
      };
    }
  };

  dataStateChange = (event) => {
    this.setState(this.createAppState(event.dataState));
  };

  onEditCell() {}
  validate_rowRender = (row, rowProps) => {
    let backgroundColor = "";
    let fontWeight = "";
    let fontSize = "12px";
    if (rowProps.dataItem.isUncommit === true) {
      backgroundColor = "#301934";
      fontWeight = "bold";
      fontSize = "16px";
    }
    // else if(rowProps.dataItem.isClosedExcelUpdate === true) {
    //   backgroundColor = "#428fed";
    //   fontWeight = "bold";
    //   fontSize = "16px";

    // }

    return React.cloneElement(
      row,
      {
        ...row.props,
        style: {
          ...row.props.style,
          backgroundColor: backgroundColor,
          fontWeight: fontWeight,
          fontSize: fontSize,
        },
      },
      row.props.children
    );
  };
  validate_cellRender = (row, cellProps) => {
    const cellField = cellProps.field;
    const dataItem = cellProps.dataItem;
    const cellValue = dataItem[cellField];
    let backgroundColor = "";
    let fontWeight = "";
    let fontSize = "12px";
   
    if (
      dataItem.updatedColumnsFromExcel &&
      dataItem.updatedColumnsFromExcel.includes(cellField)
    ) {
      backgroundColor = "#034f0e";
      fontWeight = "bold";
      fontSize = "16px";
    }
    // else if(dataItem.isClosedExcelUpdate===true && cellField==='number'){
    //   backgroundColor = "#428fed";
    //   fontWeight = "bold";
    //   fontSize = "16px";
    // }
    if (cellField === "isOpportunity") {
      return cellValue === "Threat" ? (
        <td
          style={{
            backgroundColor: backgroundColor,
            fontWeight: fontWeight,
          fontSize: fontSize,
          }}
        >
          {cellValue}
        </td>
      ) : (
        <td
          style={{
            backgroundColor: backgroundColor,
            fontWeight: fontWeight,
          fontSize: fontSize,
          }}
        >
          <span className="turquoiseBlue">{cellValue}</span>
        </td>
      );
    } else if (cellField && cellField.endsWith("_Pre")) {
      return (
        <td
          style={{
            backgroundColor: backgroundColor,
            fontWeight: fontWeight,
          fontSize: fontSize,
          }}
        >
          <span>
            {cellValue ? formatNumber(parseInt(cellValue), "##,#") : "0"}
          </span>
        </td>
      );
    } else if (cellField && cellField.endsWith("_Post")) {
      return (
        <td
          style={{
            backgroundColor: backgroundColor,
            fontWeight: fontWeight,
          fontSize: fontSize,
          }}
        >
          <span className="yellowCell">
            {cellValue ? formatNumber(parseInt(cellValue), "##,#") : "0"}
          </span>
        </td>
      );
    } else if (cellField && cellField.endsWith("_Current")) {
      return (
        <td
          style={{
            backgroundColor: backgroundColor,
            fontWeight: fontWeight,
          fontSize: fontSize,
          }}
        >
          <span className="turquoiseBlue">
            {cellValue ? formatNumber(parseInt(cellValue), "##,#") : "0"}
          </span>
        </td>
      );
    } else if (cellField === "currentProbability") {
      return (
        <td
          style={{
            backgroundColor: backgroundColor,
            fontWeight: fontWeight,
          fontSize: fontSize,
          }}
        >
          <span className="turquoiseBlue">{cellValue}</span>
        </td>
      );
    } else if (cellField === "reductionProbability") {
      return (
        <td
          style={{
            backgroundColor: backgroundColor,
            fontWeight: fontWeight,
          fontSize: fontSize,
          }}
        >
          <span className="yellowCell">{cellValue}</span>
        </td>
      );
    } else if (cellField === "isClosed") {
      return (
        <td
          style={{
            backgroundColor: backgroundColor,
            fontWeight: fontWeight,
          fontSize: fontSize,
          }}
        >
          <span>
            {cellValue.toString() == "true" || cellValue.toString() == "Open"
              ? "Open"
              : "Closed"}
          </span>
        </td>
      );
    } else if (this.checkDate(cellValue)) {
      return (
        <td
          style={{
            backgroundColor: backgroundColor,
            fontWeight: fontWeight,
          fontSize: fontSize,
          }}
        >
          <span>
            {cellValue ? moment(cellValue).format("DD-MMM-YYYY") : ""}
          </span>
        </td>
      );
    } else {
      return (
        <td
          style={{
            backgroundColor: backgroundColor,
            fontWeight: fontWeight,
          fontSize: fontSize,
          }}
          title={
            typeof cellValue === "object" ? cellValue?.toString() : cellValue
          }
        >
          <span>
            {typeof cellValue === "object" ? cellValue?.toString() : cellValue}
          </span>
        </td>
      );
    }
  };

   checkDate = (dateString) => {
    if(dateString&&dateString!=''){
      return moment(dateString, 'DD-MMM-YYYY', true).isValid();
    }
    return false;
  };
  render() {
    let isPrime =
      this.props?.orgUnit?.isPrime &&
      secureLocalStorage.getItem("isPrime") === true
        ? true
        : false;
    return (
      <div>
         {this.props.loader || this.state.loader? (
          <span className="MatTableSpinner">
            <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
          </span>
        ) : null}
        <div id="reportrisk">
          <div
            className="tblCont riskRegister dataGrids reportsGrid"
            id="rw-tab-header"
          >
            <Grid
              style={{ minHeight: "100px" }}
              data={process(this.state.riskList, this.state.dataState)}
              rowRender={this.validate_rowRender}
              cellRender={this.validate_cellRender}
              reorderable
              resizable
              {...this.state.dataState}
              onDataStateChange={this.dataStateChange}
              sortable={true}
              pageable={true}
            >
              <Column
                field="number"
                title="Risk Number"
                width="100px"
                locked={true}
                cell={ValidateNumberCell}
              />

              <Column
                field="riskTitle"
                title="Risk Title*"
                width="250px"
                
              />
              <Column
                field="isOpportunity"
                title="T/O"
                width="100px"
             
              />
              <Column
                field="name"
                title="Risk Description"
                width="200px"
                editable={false}
              />
              <Column
                field="riskTypeNames"
                title="Risk Type"
                width="150px"
              />

              {this.state.dropdownColumns}
              <Column
                field="cause"
                title="Cause"
                width="200px"
                editable={false}
                
              />
              <Column
                field="existingControl"
                title="Existing Control"
                width="200px"
                editable={false}
                
              />
              <Column
                field="frequency"
                title="Pre-Probability (%)"
                width="80px"
              />
              <Column
                field="currentProbability"
                title="Current Probability (%)"
                width="80px"
                editable={false}
                
              />
              <Column
                field="reductionProbability"
                title="Post-Probability (%)"
                width="75px"
                editable={false}
              
              />

              <Column
                field="pre"
                title="pre"
                width="75px"
                sortable={false}
                editable={false}
                cell={(props) => (
                  <PrePostComponenant
                    {...props}
                    onEditCell={this.onEditCell}
                    HeatMapConfigDataOpportunity={
                      this.state.HeatMapConfigDataOpportunity
                    }
                    HeatMapConfigDataThreat={this.state.HeatMapConfigDataThreat}
                    dynamicHeatmapProbabilityRange={
                      this.state.dynamicHeatmapProbabilityRange
                    }
                  />
                )}
              />
              <Column
                field="current"
                title="Current"
                width="75px"
                editable={false}
                sortable={false}
                cell={(props) => (
                  <PrePostComponenant
                    {...props}
                    onEditCell={this.onEditCell}
                    HeatMapConfigDataOpportunity={
                      this.state.HeatMapConfigDataOpportunity
                    }
                    HeatMapConfigDataThreat={this.state.HeatMapConfigDataThreat}
                    dynamicHeatmapProbabilityRange={
                      this.state.dynamicHeatmapProbabilityRange
                    }
                  />
                )}
              />
              <Column
                field="post"
                title="post"
                sortable={false}
                width="75px"
                editable={false}
                cell={(props) => (
                  <PrePostComponenant
                    {...props}
                    onEditCell={this.onEditCell}
                    HeatMapConfigDataOpportunity={
                      this.state.HeatMapConfigDataOpportunity
                    }
                    HeatMapConfigDataThreat={this.state.HeatMapConfigDataThreat}
                    dynamicHeatmapProbabilityRange={
                      this.state.dynamicHeatmapProbabilityRange
                    }
                  />
                )}
              />
              
              {/* <Column
                field="preRiskScore"
                title="Risk Score (Pre)"
                filter={"numeric"}
                width="80px"
                editable={false}
              /> */}

              {/* {isPrime && (
                <Column
                  field="preWeightedRiskScore"
                  title="Prime Risk Score (Pre)"
                  filter={"numeric"}
                  width="80px"
                  editable={false}
                  cell={(props) => (
                    <td>
                      <span>
                        {props.dataItem.isPrimeWorkstreams &&
                        secureLocalStorage.getItem("isPrime") === true
                          ? props.dataItem.preWeightedRiskScore
                          : ""}
                      </span>
                    </td>
                  )}
                />
              )} */}

              {/* <Column
                field="currentRiskScore"
                title="Risk Score (Current)"
                filter={"numeric"}
                width="80px"
                editable={false}
                cell={(props) => (
                  <td>
                    <span className="turquoiseBlue">
                      {props.dataItem.currentRiskScore}
                    </span>
                  </td>
                )}
              /> */}

              {/* {isPrime && (
                <Column
                  field="currentWeightedRiskScore"
                  title="Prime Risk Score (Current)"
                  filter={"numeric"}
                  width="80px"
                  editable={false}
                  cell={(props) => (
                    <td>
                      <span className="turquoiseBlue">
                        {props.dataItem.isPrimeWorkstreams &&
                        secureLocalStorage.getItem("isPrime") === true
                          ? props.dataItem.currentWeightedRiskScore
                          : ""}
                      </span>
                    </td>
                  )}
                />
              )} */}

              {/* <Column
                field="postRiskScore"
                title="Risk Score (Post)"
                filter={"numeric"}
                width="80px"
                editable={false}
                cell={(props) => (
                  <td>
                    <span className="yellowCell">
                      {props.dataItem.postRiskScore}
                    </span>
                  </td>
                )}
              /> */}

              {/* {isPrime && (
                <Column
                  field="postWeightedRiskScore"
                  title="Prime Risk Score (Post)"
                  filter={"numeric"}
                  width="80px"
                  editable={false}
                  cell={(props) => (
                    <td>
                      <span className="yellowCell">
                        {props.dataItem.isPrimeWorkstreams &&
                        secureLocalStorage.getItem("isPrime") === true
                          ? props.dataItem.postWeightedRiskScore
                          : ""}
                      </span>
                    </td>
                  )}
                />
              )} */}
              {/* End  */}
              {this.state.impactColumns}
              <Column
                field="impactComments"
                title="Consequences"
                width="220px"
                editable={false}
                // columnMenu={ColumnMenu}
              />
              <Column
                field="proximityDate"
                title="Proximity Date"
                width="120px"
                editor="date"
                filter={"date"}
                editable={false}
                format="{0:dd-MMM-yyyy}"
                // columnMenu={ColumnMenu}
              />
              <Column
                field="owner"
                title="Owner"
                width="120px"
                editable={false}
                // columnMenu={ColumnMenu}
              />
              {/* <Column
                field="riskFieldsCompletion"
                title="% of fields completed"
                width="120px"
                editable={false}
              /> */}
              <Column field="progress" width="100px" title="Progress Status" />
              <Column
                field="isClosed"
                title="Status"
                width="70px"
                editable={false}
                filter={"boolean"}
              />
              {/* <Column
                field="createdDate"
                width="100px"
                title="Created Date"
                filter={"date"}
                format="{0:dd-MMM-yyyy}"
                editable={false}
              />
              <Column
                field="createdByName"
                width="100px"
                title="Created By"
                editable={false}
              /> */}
            </Grid>
          </div>
        </div>
      </div>
    );
  }
}
